module.exports = __webpack_public_path__ + "static/media/rebirth_sample_11.8527e904.jpg";